// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-snapshot .react-select__single-value {
  width: 100%;
}

.select-snapshot .react-select__value-container {
  min-height: 38px;
  padding: 0 8px;
}

.select-snapshot .react-select__menu {
  --tw-text-opacity: 1;
  color: rgb(50 50 50 / var(--tw-text-opacity));
  border-width: var(--base-sizes-1px);
  --tw-border-opacity: 1;
  border-style: solid;
  border-top-width: 0;
  border-color: rgb(38 65 131 / var(--tw-border-opacity));
}

.select-snapshot.react-select--is-disabled .react-select__placeholder {
  --tw-text-opacity: 1;
  color: rgb(140 140 140 / var(--tw-text-opacity));
}

.select-snapshot__spinner {
  --tw-text-opacity: 1;
  color: rgb(38 65 131 / var(--tw-text-opacity));
  font-size: 1.15em;
}

.select-snapshot__spinner-wrapper {
  --tw-text-opacity: 1;
  color: rgb(50 50 50 / var(--tw-text-opacity));
  text-align: right;
  flex: 1;
  align-self: center;
  margin-right: 2px;
  display: block;
}

.select-snapshot__value-wrapper {
  --tw-text-opacity: 1;
  color: rgb(50 50 50 / var(--tw-text-opacity));
  font-size: 14px;
}

.select-snapshot .react-select__control--is-focused {
  border-color: #264183 !important;
}

.select-snapshot-option__item-wrapper {
  flex-direction: row;
  padding: 3px 0 2px 5px;
  font-size: 14px;
  display: flex !important;
}

.select-snapshot-option__spinner-wrapper {
  color: #333;
  text-align: right;
  flex: 1;
  align-self: center;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/SelectSnapshot/SelectSnapshot.css","webpack://./services/frontend/app/components/SelectSnapshot/SelectSnapshot.css"],"names":[],"mappings":"AADA;ECEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;EAC7C,mCAAmC;EACnC,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;EAC7C,iBAAiB;EACjB,OAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,OAAO;EACP,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".select-snapshot .react-select__single-value {\n    width: 100%;\n  }\n  .select-snapshot .react-select__value-container {\n    min-height: 38px;\n    padding: 0 8px;\n  }\n  .select-snapshot .react-select__menu {\n    --tw-text-opacity: 1;\n    color: rgb(50 50 50 / var(--tw-text-opacity));\n    border-width: var(--base-sizes-1px);\n    border-style: solid;\n    border-top-width: 0;\n    --tw-border-opacity: 1;\n    border-color: rgb(38 65 131 / var(--tw-border-opacity));\n}\n  .select-snapshot.react-select--is-disabled .react-select__placeholder {\n    --tw-text-opacity: 1;\n    color: rgb(140 140 140 / var(--tw-text-opacity));\n}\n\n.select-snapshot__spinner {\n    --tw-text-opacity: 1;\n    color: rgb(38 65 131 / var(--tw-text-opacity));\n\n  font-size: 1.15em;\n}\n\n.select-snapshot__spinner-wrapper {\n    --tw-text-opacity: 1;\n    color: rgb(50 50 50 / var(--tw-text-opacity));\n\n  align-self: center;\n  display: block;\n  flex: 1;\n  margin-right: 2px;\n  text-align: right;\n}\n\n.select-snapshot__value-wrapper {\n    --tw-text-opacity: 1;\n    color: rgb(50 50 50 / var(--tw-text-opacity));\n\n  font-size: 14px;\n}\n\n.select-snapshot .react-select__control--is-focused {\n  border-color: #264183 !important;\n}\n\n.select-snapshot-option__item-wrapper {\n  display: flex !important;\n  flex-direction: row;\n  font-size: 14px;\n  padding: 3px 0 2px 5px;\n}\n\n.select-snapshot-option__spinner-wrapper {\n  color: #333;\n  display: block;\n  flex: 1;\n  text-align: right;\n  align-self: center;\n}\n",".select-snapshot .react-select__single-value {\n  width: 100%;\n}\n\n.select-snapshot .react-select__value-container {\n  min-height: 38px;\n  padding: 0 8px;\n}\n\n.select-snapshot .react-select__menu {\n  --tw-text-opacity: 1;\n  color: rgb(50 50 50 / var(--tw-text-opacity));\n  border-width: var(--base-sizes-1px);\n  --tw-border-opacity: 1;\n  border-style: solid;\n  border-top-width: 0;\n  border-color: rgb(38 65 131 / var(--tw-border-opacity));\n}\n\n.select-snapshot.react-select--is-disabled .react-select__placeholder {\n  --tw-text-opacity: 1;\n  color: rgb(140 140 140 / var(--tw-text-opacity));\n}\n\n.select-snapshot__spinner {\n  --tw-text-opacity: 1;\n  color: rgb(38 65 131 / var(--tw-text-opacity));\n  font-size: 1.15em;\n}\n\n.select-snapshot__spinner-wrapper {\n  --tw-text-opacity: 1;\n  color: rgb(50 50 50 / var(--tw-text-opacity));\n  text-align: right;\n  flex: 1;\n  align-self: center;\n  margin-right: 2px;\n  display: block;\n}\n\n.select-snapshot__value-wrapper {\n  --tw-text-opacity: 1;\n  color: rgb(50 50 50 / var(--tw-text-opacity));\n  font-size: 14px;\n}\n\n.select-snapshot .react-select__control--is-focused {\n  border-color: #264183 !important;\n}\n\n.select-snapshot-option__item-wrapper {\n  flex-direction: row;\n  padding: 3px 0 2px 5px;\n  font-size: 14px;\n  display: flex !important;\n}\n\n.select-snapshot-option__spinner-wrapper {\n  color: #333;\n  text-align: right;\n  flex: 1;\n  align-self: center;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
